import ModalOptions from "@/ts/base/Interfaces/ModalOptions";

class ModalTemplate {
	private _id: string = "";
	private _title: string = "";
	private _message: string = "";
	private _variant: string = "info";
	private _buttons: string[] = [];

	constructor(options?: ModalOptions) {
		if (options) {
			this._id = options.id || "";
			this._title = options.title || "";
			this._message = options.message || "";
			this._variant = options.variant || "info";
			this._buttons = options.buttons || [];
		}
	}

	public get id(): string {
		return this._id;
	}

	public set id(value: string) {
		this._id = value;
	}

	public get title(): string {
		return this._title;
	}

	public set title(value: string) {
		this._title = value;
	}

	public get message(): string {
		return this._message;
	}

	public set message(value: string) {
		this._message = value;
	}

	public get variant(): string {
		return this._variant;
	}

	public set variant(value: string) {
		this._variant = value;
	}

	public get buttons(): string[] {
		return this._buttons;
	}

	public set buttons(value: string[]) {
		this._buttons = value;
	}

	public get html(): string {
		let footer = "";
		if (this.buttons.length > 0) {
			footer = `
				<div class="modal-footer">${this.buttons.join("\n")}</div>
			`;
		}
		return `
			<div class="modal variant-${this.variant}" tabindex="-1">
			  <div class="modal-dialog">
				<div class="modal-content">
				  <div class="modal-header">
					<h5 class="modal-title">${this.title}</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				  </div>
				  <div class="modal-body">${this.message}</div>
				  ${footer}
				</div>
			  </div>
			</div>
		`;
	}

	public insert(): HTMLElement {
		document.body.innerHTML += this.html;

		const collection = document.body.querySelectorAll(".modal");
		const out = <HTMLElement>collection.item(collection.length - 1);

		if (this.id.length > 0) {
			out.id = this.id;
		}

		out.addEventListener("hide.bs.modal", () => {
			out.remove();
		});

		return out;
	}

}

export default ModalTemplate;
